module.exports = __webpack_public_path__ + "img/75647.0e5a9c74.svg";